export default "__VITE_ASSET__19c46d7d__"